import React, { useEffect, useState } from "react";

function EditTag({ tag, tagUpdate, tagDelete }) {
    const [tagDetail, setTagDetail] = useState({ tag });
    useEffect(() => {
        setTagDetail(tag)
    }, [tag]);

    return (
        <div className="col-md-12">
            <hr className="mt-0" />
            <div className="row align-items-end">
                <div class="form-group col-md-5 mb-0">
                    <label for="exampleInputTitle">Title</label>
                    <textarea class="form-control" onChange={(e) => setTagDetail({
                        ...tagDetail,
                        title: e.target.value,
                    })} value={tagDetail.title}></textarea>
                </div>
                <div class="form-group col-md-5  mb-0">
                    <label for="exampleInputLink">Link</label>
                    <textarea class="form-control" onChange={(e) => setTagDetail({
                        ...tagDetail,
                        link: e.target.value,
                    })} value={tagDetail.link}></textarea>
                </div>
                <div className="col-md-2 d-flex">
                    <button class="btn btn-primary mr-2" onClick={() => tagUpdate(tagDetail)}>Update</button>
                    <button class="btn btn-danger" onClick={() => tagDelete(tagDetail.id)}><i className="fa fa-trash"></i></button>
                </div>
            </div>
        </div>
    )
}

export default EditTag